var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChecking = function SvgChecking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Checking_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#2E9AE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Checking_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#757D8A",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.668 10.337a2.668 2.668 0 1 0 0-5.337 2.668 2.668 0 0 0 0 5.337ZM11.4 11.4 9.556 9.556",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export { SvgChecking as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPG1hc2sgaWQ9Im1hc2swXzExNzk0XzEwODM0IiBzdHlsZT0ibWFzay10eXBlOmFscGhhIiBtYXNrVW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTYiIGhlaWdodD0iMTYiPgo8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgZmlsbD0iIzJFOUFFNCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfMTE3OTRfMTA4MzQpIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSIjNzU3RDhBIi8+CjxwYXRoIGQ9Ik03LjY2ODMgMTAuMzM2NkM5LjE0MTk2IDEwLjMzNjYgMTAuMzM2NiA5LjE0MTk2IDEwLjMzNjYgNy42NjgzQzEwLjMzNjYgNi4xOTQ2NCA5LjE0MTk2IDUgNy42NjgzIDVDNi4xOTQ2NCA1IDUgNi4xOTQ2NCA1IDcuNjY4M0M1IDkuMTQxOTYgNi4xOTQ2NCAxMC4zMzY2IDcuNjY4MyAxMC4zMzY2WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjQwMDggMTEuNDAwOEw5LjU1NDY5IDkuNTU0NjkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPC9zdmc+Cg==";